import { Box, Stack, Text } from "@storyofams/react-ui";
import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react";
import { CustomCheckbox } from "~components/common/CustomCheckbox";
import { useRecipeCart } from "./CartProvider";
import { IngredientItem } from "./IngredientItem";

export const IngredientsTable = ({ products, isOptional = false }) => {
  const { ingredientsToCart, setIngredients, setMainProducts } =
    useRecipeCart();
  const { query } = useRouter();
  const [currentProducts, setCurrentProducts] = useState([]);
  useEffect(() => {
    setCurrentProducts(products.filter((item) => item.availableForSale));
    if (!isOptional) {
      setIngredients(
        products.filter(({ availableForSale }) => availableForSale)
      );
      setMainProducts(
        products
          .filter((item) => item.availableForSale && !item.optional)
          .map((item) => ({
            id: item.id,
            alt: item.alternativeIds.map((item) => item?.id).join(","),
          }))
      );
    }
  }, [products, query.slug]);
  const setNewProduct = (oldProd, newProd) => {
    setCurrentProducts((products) => [
      ...products.filter((item) => item.id !== oldProd.id),
      newProd,
    ]);
  };
  const checked = useMemo(
    () =>
      currentProducts
        .filter((item) => item.availableForSale)
        .every((item) => {
          return ingredientsToCart.find((prod) => item.id === prod.id);
        }) && !!currentProducts.length,
    [ingredientsToCart, products]
  );
  const handleClick = () => {
    if (checked) {
      setIngredients(
        ingredientsToCart.filter(
          (item) => !currentProducts.find((prod) => prod.id === item.id)
        )
      );
    } else
      setIngredients([
        ...new Set([
          ...ingredientsToCart,
          ...currentProducts.filter((item) => item.availableForSale),
        ]),
      ]);
  };
  return (
    <Box
      mt={[isOptional ? 2 : 0, isOptional ? 2 : 2]}
      onClick={(e) => e.stopPropagation()}
      border={"1px solid #E2DFDF"}
      borderRadius={"8px"}
      overflow={"visible"}
    >
      <Box
        display={"flex"}
        alignItems={"center"}
        backgroundColor={"#FCF9F7"}
        justifyContent={"space-between"}
        px={1}
        height={"46px"}
        borderTopRightRadius={"8px"}
        borderTopLeftRadius={"8px"}
      >
        <Stack space={["6px", "10px"]} alignItems={"center"}>
          <Box
            border={"1px solid #E2DFDF"}
            width={20}
            cursor={"pointer"}
            borderRadius={"3px"}
            overflow={"hidden"}
            onClick={handleClick}
            height={20}
          >
            <CustomCheckbox checked={checked} />
          </Box>
          <Text
            width={["34px", "40px"]}
            fontFamily={"DINPro"}
            fontSize={"12px"}
            letterSpacing={["auto", "0.1em"]}
            fontWeight={500}
            lineHeight={"16.2px"}
            textAlign={"end"}
            pt="2px"
            flexShrink={0}
          >
            GRAM
          </Text>
          <Text
            fontFamily={"DINPro"}
            fontSize={"12px"}
            letterSpacing={["auto", "0.1em"]}
            fontWeight={500}
            lineHeight={"16.2px"}
            pt="2px"
          >
            {"PRODUCTEN"}
          </Text>
        </Stack>
      </Box>
      {products.map((item, i) => (
        <IngredientItem
          key={item.id + i}
          product={item}
          setNewProduct={setNewProduct}
        />
      ))}
    </Box>
  );
};
